export const EVENT_TYPES = ["Academic", "Extra Curricular"];
export const EVENT_NAMES = [
  { label: "SCORE", value: "SCORE" },
  { label: "HOTS", value: "Hots Olympiad" },
  { label: "English Olympiad", value: "English Olympiad" },
  { label: "Maths Olympiad", value: "Math Olympiad" },
  { label: "WIT", value: "WIT" },
  { label: "I-EMSAT", value: "I-EMSAT" },
  { label: "Career Counselling", value: "Career Counselling" },
];
